<template>
  <NavItem :item="item">
    <template #badge>
      <TagView
        v-if="showCount"
        :type="item.badge.type"
        :rounded="true"
        class="m-l-2"
        :data-e2e="NotificationCypressAttribute.views.NOTIFICATION_COUNT"
      >
        {{ notificationCount }}
      </TagView>
    </template>
  </NavItem>
</template>

<script>
import NavItemComponent from '/@/modules/core/nav/components/NavItem.vue';
import { NavItem } from '/@/modules/core/nav/models/NavItem';
import BroadcastService from '@/integrations/pusher/BroadcastService';
import UserNotificationService from '/@/modules/notification/services/UserNotificationService';
import { NotificationCypressAttribute } from '@/modules/notification/constants/NotificationCypressAttribute';
import TagView from '@/modules/core/ui/components/wrappers/TagView.vue';
import { state } from '/@/modules/core/app/helpers/store';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'NotificationsNavItem',
  components: { TagView, NavItem: NavItemComponent },
  props: {
    item: {
      type: NavItem
    }
  },
  static: {
    NotificationCypressAttribute
  },
  computed: {
    notificationCount() {
      return state.notification.unreadNotificationCount;
    },
    showCount() {
      return this.notificationCount > 0;
    }
  },
  methods: {
    async init() {
      await UserNotificationService.getUnreadCount();
    }
  },
  created() {
    this.init();
  }
};
</script>
